import { render, staticRenderFns } from "./loaderIcon.vue?vue&type=template&id=6307d546&scoped=true&"
import script from "./loaderIcon.vue?vue&type=script&lang=js&"
export * from "./loaderIcon.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "6307d546",
  null
  ,true
)

export default component.exports